import { allFeaturesAtFalse, type Features } from './default'

export const features: Features = {
  ...allFeaturesAtFalse,
  home: {
    ...allFeaturesAtFalse.home,
    advantages: true,
  },
  certificates: {
    phyto: true,
    explosive: true,
  },
  contact: {
    mailTo: 'contact@farmi.com',
  },
  shoppingList: true,
  header: {
    leftEntries: [
      {
        name: 'Accueil',
        path: '/',
      },
      {
        name: 'Appro',
        path: '/shop',
      },
      {
        name: 'Collecte',
        path: '/collect',
      },
      {
        name: 'Agro Pilot',
        path: '/agro-pilot',
      },
    ],
    secondaryLogo: '/themes/current/images/logo_2.svg',
  },
  footer: {
    ...allFeaturesAtFalse.footer,
    apps: {
      iOS: 'https://apps.apple.com/fr/app/farmi/id1272774852',
      Android: 'https://play.google.com/store/apps/details?id=com.soufflet.farmi&hl=fr&gl=US&pli=1',
    },
    social: {
      facebook: 'https://www.facebook.com/people/Farmi/100069885982525/',
      linkedin: 'https://www.linkedin.com/company/soufflet-agriculture',
      x: 'https://twitter.com/Soufflet_Agri',
      youtube: 'https://www.youtube.com/channel/UCdPjArAnZWLw1GYQxLxLuaQ',
    },
    sponsor: {
      config: {
        altText: 'Soufflet Agriculture',
        homePageUrl: 'https://www.invivo-group.com/fr/activites/agriculture/soufflet-agriculture',
        logo: '/themes/farmi/images/logo/soufflet-white-transparent.png',
      },
    },
  },
  pdp: {
    templateB2AGFeature: true,
    showOnlyMainImage: true,
    showSupplier: false,
    showBenefits: true,
  },
  checkoutV2: {
    displayRpd: true,
    displayMention: true,
    selectionByProducts: true,
    blockAddressForPricerOffer: true,
    displayToBeCalulated: true,
  },
  server: {
    currentTheme: {
      canBeChangeAtRuntime: true,
      partnerThemesList: new Map([['10', 'soufflet-vigne']]),
    },
  },
  platform: {
    name: 'Farmi',
  },
}
